export const container = ({ width }) => ({
    width,
    position: 'relative',
});
